// Project IDs (from the backend trip listing) that correspond to Sofest trips.
// When the user clicks one of these on /all-trips (or anywhere using project_id
// navigation), we redirect to the Sofest landing page for that trip instead of
// the generic /trips/<project_id> page.
export const SOFEST_PROJECT_ID_TO_SLUG = {
  685: "summer-madness",
  689: "summer-madness",
  690: "christmas-in-the-mountains",
  665: "mountain-of-madness",
  691: "end-season-france-switzerland",
  749: "mongolia-summer-festival",
};

// Trip IDs (booking IDs) that correspond to Sofest trips. Used to redirect from
// /trip/<trip_id> to the Sofest landing page.
// TODO: 11112 and 11113 are placeholders — replace with the real trip IDs once
// the Christmas, Mountain of Madness, and End Season trips are created.
export const SOFEST_TRIP_ID_TO_SLUG = {
  3177: "summer-madness",
  3194: "summer-madness",
  3192: "christmas-in-the-mountains",
  3190: "mountain-of-madness",
  3191: "end-season-france-switzerland",
  3641: "mongolia-summer-festival",
};

// Project IDs that should redirect to the /sofest landing page itself (rather
// than a specific /sofest/trips/<slug> page). Used to consolidate stale,
// SEO-indexed trip URLs onto the main Sofest landing page.
export const SOFEST_LANDING_PROJECT_IDS = new Set([178]);

// Booking trip IDs that should resolve to the main Sofest landing page instead
// of a trip-specific Sofest detail route.
export const SOFEST_LANDING_TRIP_IDS = new Set([]);

export const SOFEST_SLUG_TO_PROJECT_ID = Object.fromEntries(
  Object.entries(SOFEST_PROJECT_ID_TO_SLUG).map(([id, slug]) => [slug, Number(id)])
);

export function getSofestTripPath(projectId) {
  const slug = SOFEST_PROJECT_ID_TO_SLUG[projectId];
  return slug ? `/sofest/trips/${slug}` : null;
}

// Resolves a Sofest redirect path from any /trip/:trip_id or /trips/:project_id
// route param. Accepts string or number — useParams returns strings.
export function getSofestRedirectFromRouteParams({ trip_id, project_id }) {
  if (project_id != null && SOFEST_LANDING_PROJECT_IDS.has(Number(project_id))) {
    return "/sofest";
  }
  if (project_id != null) {
    const slug = SOFEST_PROJECT_ID_TO_SLUG[Number(project_id)];
    if (slug) return `/sofest/trips/${slug}`;
  }
  if (trip_id != null) {
    if (SOFEST_LANDING_TRIP_IDS.has(Number(trip_id))) return "/sofest";
    const slug = SOFEST_TRIP_ID_TO_SLUG[Number(trip_id)];
    if (slug) return `/sofest/trips/${slug}`;
  }
  return null;
}
